/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */

const globalScripts = () => {};

export { globalScripts as g };

//# sourceMappingURL=app-globals-0f993ce5.js.map